import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfettiService {
  private showConfettiFlag = false;

  setShowConfetti(flag: any): void {
    this.showConfettiFlag = flag;
  }

  getShowConfetti(): boolean {
    return this.showConfettiFlag;
  }

  reset(): void {
    this.showConfettiFlag = false;
  }
}



